import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyGraph = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.64478 5.04673V4.41602",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.64478 10.7232V10.0925",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.90604 5.04669H7.19638C6.93436 5.04687 6.68058 5.13822 6.47855 5.30506C6.27652 5.4719 6.13883 5.70384 6.08911 5.9611C6.03939 6.21835 6.08073 6.48489 6.20604 6.715C6.33135 6.9451 6.53283 7.12444 6.7759 7.22224L8.51164 7.91603C8.75526 8.01349 8.9573 8.19279 9.08303 8.42309C9.20876 8.6534 9.25031 8.92032 9.20054 9.17794C9.15077 9.43557 9.01278 9.6678 8.81031 9.8347C8.60784 10.0016 8.35355 10.0927 8.09116 10.0924H6.38318",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9525 7.68816C13.9525 4.27054 11.182 1.5 7.76434 1.5C4.34671 1.5 1.57617 4.27054 1.57617 7.68816C1.57617 9.48091 2.33852 11.0956 3.55672 12.2258",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4239 13.4258V10.5697H11.5679",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4237 10.5697L11.9375 13.0559C11.8437 13.1497 11.7165 13.2024 11.5839 13.2024H8.63727C8.50466 13.2024 8.37749 13.2551 8.28372 13.3488L7.13257 14.5",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgCurrencyGraph;
